module.exports = __webpack_public_path__ + "img/DSC_0091.d73c8e11.jpg";